import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

const WorkflowDetails = ({ details, onChange }) => {
  const handleInputChange = (field, value) => {
    onChange({ ...details, [field]: value });
  };

  const priorityOptions = Array.from({ length: 100 }, (_, i) => i + 1); // Create options from 1 to 100

  return (
    <div className="p-8 bg-white rounded-lg shadow-xl space-y-10">
      <h2 className="text-xl font-extrabold text-gray-800 tracking-wide">
        Workflow Details
      </h2>

      <div className="space-y-8">
        {/* Name Field */}
        <div className="space-y-3">
          <label className="block text-md font-semibold text-gray-700">
            Workflow Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={details.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
            className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-4 focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none shadow-md transition duration-200"
            placeholder="Enter the workflow name"
          />
        </div>

        {/* Active Checkbox */}
        <div className="flex items-center space-x-4">
          <input
            type="checkbox"
            checked={details.active}
            onChange={(e) => handleInputChange("active", e.target.checked)}
            className="w-6 h-6 text-indigo-600 border-gray-300 rounded focus:ring-4 focus:ring-indigo-500"
          />
          <label className="text-md font-semibold text-gray-700">Active</label>
        </div>

        {/* Priority Field */}
        <div className="space-y-3">
          <label className="text-md font-semibold text-gray-700 flex items-center space-x-2">
            <span>
              Priority <span className="text-red-500">*</span>
            </span>
            <FaInfoCircle
              className="text-gray-500 hover:text-gray-700 cursor-pointer"
              title="Priority determines the sequence of approval chains and its relative position to the management hierarchy. A number below 50 indicates this approval chain comes before management hierarchy. The lowest number chain will come first."
            />
          </label>
          <select
            value={details.priority}
            onChange={(e) => handleInputChange("priority", e.target.value)}
            className="w-full border border-gray-300 px-4 py-3 rounded-lg focus:ring-4 focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none shadow-md transition duration-200"
          >
            <option value="" disabled>
              Select Priority
            </option>
            {priorityOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Description for Priority */}
        <div className="p-5 bg-gray-100 rounded-lg shadow-md">
          <p className="text-base text-gray-600 leading-relaxed">
            Priority determines the sequence of approval chains and its relative
            position to the management hierarchy, which is assumed to be
            priority of 50. A number below 50 indicates that this approval chain
            comes before management hierarchy. If two or more approval chains
            are needed to review an invoice, the lowest number chain will come
            first.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WorkflowDetails;
